import { interfaceMethod } from '@/api/tmsApiController'
import { getUserInfo } from '@/utils/common'

export function formatApi (params) {
  const _data: any = {}
  const _dataInfo = params.data || {}
  Object.keys(_dataInfo).forEach((key) => {
    const _value = _dataInfo[key]
    const _key = key.toLowerCase()
    if (_key === 'm') {
      _data[_key] = _value.toLowerCase()
    } else if (_key === 'u' && _value && Object.keys(_value).length > 0) {
      _data[_key] = getUserInfo(_value)
    } else {
      _data[_key] = _value
    }
  })
  return _data
}

/**
 * 格式化.net的统一请求接口，适配java版本接口
 * @param data
 * @param params
 */
export function customRequest (data, params) {
  const _data = formatApi(params)
  if (!_data.m || !_data.n) {
    window.ShowERR('非法请求')
    return Promise.reject(new Error('非法请求'))
  }
  return interfaceMethod(_data)
}
